<template>
    <v-dialog v-model="dialog"
              @click:outside="closeDialog"
              scrollable
              max-width="700px"
    >
        <v-card>
            <address-finder @address-confirmed="fillAddress" ref="addressFinderDialog"></address-finder>
            <create-company-dialog @created="fillCompany" ref="createCompanyDialog"></create-company-dialog>
            <create-user-dialog @created="fillUser" ref="createUserDialog"></create-user-dialog>
            <v-toolbar dense :elevation="0">
                <v-toolbar-title class="text-primary-700">
                    New Standalone Property
                </v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-btn style="width: 35px; height: 35px" icon @click="closeDialog">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pt-4">
                <form>
                  
                  <template id="section-address">
                    <div style="display: flex; z-index: 20;">
                      <h5 class="text-h7 mb-1 pa-0">Address</h5>
                      <v-spacer></v-spacer>
                      <a style="z-index: 20" @click="selectAddress" class="text-caption">Fill From Map <v-icon small color="primary">mdi-map-marker</v-icon></a>
                    </div>
                    
                    <v-row>
                      <v-col cols="12">
                        <div class="v-input v-input--hide-details v-input--dense theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined">
                          <div class="v-input__control">
                            <div class="v-input__slot">
                              <fieldset aria-hidden="true"><legend style="width: 45.75px;"><span class="notranslate">​</span></legend></fieldset>
                              <div class="v-text-field__slot">
                                <label for="input-680" class="v-label v-label--active theme--light" style="left: 0px; right: auto; position: absolute;">Autofill</label>
                                <!-- <label for="input-349" class="v-label theme--light" style="left: 0px; right: auto; position: absolute;">Street</label> -->
                                <GmapAutocomplete ref="autocompleteRef" @input="place = $event.target.value" @place_changed="changePlace"></GmapAutocomplete>
                              </div>
                            </div>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6">
                            <v-text-field
                            outlined
                            dense
                            hide-details
                            v-model="form.address.street"
                            v-validate="''"
                            :error-messages="errors.collect('form.address.street')"
                            label="Street"
                            data-vv-name="form.address.street"
                            data-vv-as="Street"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                            outlined
                            dense
                            hide-details
                            v-model="form.address.street2"
                            v-validate="''"
                            :error-messages="errors.collect('form.address.street2')"
                            label="Street 2 (Optional)"
                            data-vv-name="form.address.street2"
                            data-vv-as="Street 2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                    <v-col cols="4">
                        <v-text-field
                        outlined
                        dense
                        hide-details
                        v-model="form.address.city"
                        v-validate="''"
                        :error-messages="errors.collect('form.address.city')"
                        label="City"
                        data-vv-name="form.address.city"
                        data-vv-as="City"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                        <v-text-field
                        outlined
                        dense
                        hide-details
                        v-model="form.address.region"
                        v-validate="''"
                        :error-messages="errors.collect('form.address.region')"
                        label="Region"
                        data-vv-name="form.address.region"
                        data-vv-as="Region"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                        <v-text-field
                        outlined
                        dense
                        hide-details
                        v-model="form.address.post_code"
                        v-validate="''"
                        :error-messages="errors.collect('form.address.post_code')"
                        label="Post Code"
                        data-vv-name="form.address.post_code"
                        data-vv-as="Post Code"
                        ></v-text-field>
                    </v-col>

                    </v-row>
                    <v-row>
                        
                      <v-col cols="12">
                          <v-autocomplete
                          outlined
                          dense
                          hide-details
                          v-model="form.address.country"
                          :items="countries"
                          cache-items
                          flat
                          hide-no-data
                          item-text="name"
                          item-value="name"
                          label="Country"
                          v-validate="''"
                          :error-messages="errors.collect('form.address.country')"
                          data-vv-name="form.address.country"
                          data-vv-as="Country"
                          ></v-autocomplete>
                      </v-col>
                      <!-- <v-col cols="4">
                            <v-text-field
                                outlined
                                dense
                                hide-details
                                v-model="form.building_num"
                                v-validate="''"
                                :error-messages="errors.collect('form.building_num')"
                                label="Unit"
                                data-vv-name="form.building_num"
                                data-vv-as="Unit"
                            ></v-text-field>
                        </v-col> -->
                    <v-col cols="12">
                        <v-textarea
                            outlined
                            dense
                            hide-details  
                            v-model="form.address.notes"
                            v-validate="''"
                            :error-messages="errors.collect('form.address.notes')"
                            label="Notes"
                            data-vv-as="Notes"
                            data-vv-name="form.address.notes"
                            auto-grow
                            rows="1"
                        ></v-textarea>
                    </v-col>
                    </v-row>
                  </template>
                  
                  <v-divider class="my-8"></v-divider>

                  <template id="section-property-info">
                    <h5 class="text-h7 mb-1 pa-0">Property Info</h5>

                    <v-row>
                        <v-col cols="6">
                         
                            <v-autocomplete
                                outlined
                                dense
                                hide-details
                                v-model="form.company_id"
                                :loading="tenants.loading"
                                :items="tenants.items"
                                :search-input.sync="tenants.search"
                                cache-items
                                flat
                                hide-no-data
                                return-object
                                clearable
                                item-text="name"
                                item-value="id"
                                label="Tenant"
                                v-validate="''"
                                :error-messages="errors.collect('form.company_id')"
                                data-vv-name="form.company_id"
                                data-vv-as="Tenant"
                            >
                             <template v-slot:append>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <v-icon @click="createCompany(0)"v-on="on">mdi-plus</v-icon>
                                </template>
                                <span>Create a new tenant</span>
                              </v-tooltip>
                            </template> 
                            <template v-slot:item="{ item }">
                              <v-list-item-content>
                                <v-list-item-title>
                                  {{ item.name }}
                                  <v-tooltip bottom v-if="item.core_id && item.scraper">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon
                                      small
                                        :color="verifyRetailer(item).icon"
                                        v-bind="attrs"
                                        v-on="on"
                                      >
                                        mdi-checkbox-marked-circle-outline
                                      </v-icon>
                                    </template>
                                    <span>{{verifyRetailer(item).tooltip}}</span>
                                  </v-tooltip>
                                </v-list-item-title>
                              </v-list-item-content>
                            </template>
									
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="6">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-autocomplete
                                outlined
                                dense
                                v-model="form.legal_tenant_id"
                                :loading="legalTenants.loading"
                                :items="legalTenants.items"
                                :search-input.sync="legalTenants.search"
                                cache-items
                                flat
                                return-object
                                hide-details
                                hide-no-data
                                clearable
                                v-on="on"
                                item-text="name"
                                item-value="id"
                                label="Tenant (Legal)"
                                v-validate="''"
                                :error-messages="errors.collect('form.legal_tenant_id')"
                                data-vv-name="form.legal_tenant_id"
                                data-vv-as="Tenant (Legal)"
                            >
                              <template v-slot:append>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <v-icon @click="createCompany(1)" v-on="on">mdi-plus</v-icon>
                                  </template>
                                  <span>Create a new tenant</span>
                                </v-tooltip>
                              </template>
                              <template v-slot:item="{ item }">
                                <v-list-item-content>
                                  <v-list-item-title>
                                    {{ item.name }}
                                    <v-tooltip bottom v-if="item.core_id">
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                        small
                                          :color="verifyRetailer(item).icon"
                                          v-bind="attrs"
                                          v-on="on"
                                        >
                                          mdi-checkbox-marked-circle-outline
                                        </v-icon>
                                      </template>
                                      <span>{{verifyRetailer(item).tooltip}}</span>
                                    </v-tooltip>
                                  </v-list-item-title>
                                </v-list-item-content>
                              </template>

                            </v-autocomplete>
                            </template>
                            <span>Optionally set the company which is the legal tenant, <br/>if it is different. e.g. A franchisee</span>
                          </v-tooltip>
                        </v-col>
                        
                    </v-row>
                    <v-row>
                        <v-col cols="6">
                            <v-autocomplete
                                outlined
                                small-chips
                                deletable-chips
                                multiple
                                hide-details
                                v-model="form.tenant_agents"
                                :loading="tenantAgents.loading"
                                :items="tenantAgents.items"
                                :search-input.sync="tenantAgents.search"
                                cache-items
                                return-object
                                flat
                                hide-no-data
                                clearable
                                item-text="name"
                                item-value="id"
                                label="Tenant Agents"
                                v-validate="''"
                                :error-messages="errors.collect('form.tenant_agents')"
                                data-vv-name="form.tenant_agents"
                                data-vv-as="Tenant Agent"
                            >
                              <template v-slot:append>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <v-icon @click="createCompany(2)" v-on="on">mdi-plus</v-icon>
                                  </template>
                                  <span>Create a new tenant agent</span>
                                </v-tooltip>
                              </template>
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="6">
                            <v-autocomplete
                                outlined
                                small-chips
                                deletable-chips
                                multiple
                                hide-details
                                v-model="form.tenant_agent_contacts"
                                :loading="tenantAgentContacts.loading"
                                :items="tenantAgentContacts.items"
                                :search-input.sync="tenantAgentContacts.search"
                                cache-items
                                flat
                                return-object
                                hide-no-data
                                clearable
                                item-text="name"
                                item-value="id"
                                label="Tenant Agent Contacts"
                                v-validate="''"
                                :error-messages="errors.collect('form.tenant_agent_contacts')"
                                data-vv-name="form.tenant_agent_contacts"
                                data-vv-as="Tenant Agent Contact"
                            >
                              <template v-slot:append>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <v-icon @click="createUser(0)" v-on="on">mdi-plus</v-icon>
                                  </template>
                                  <span>Create a new tenant agent contact</span>
                                </v-tooltip>
                              </template>
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="6">
                            <v-autocomplete
                                outlined
                                small-chips
                                deletable-chips
                                multiple
                                hide-details
                                v-model="form.tenant_contacts"
                                :loading="tenantContacts.loading"
                                :items="tenantContacts.items"
                                :search-input.sync="tenantContacts.search"
                                cache-items
                                flat
                                return-object
                                hide-no-data
                                clearable
                                item-text="name"
                                item-value="id"
                                label="Tenant Contacts"
                                v-validate="''"
                                :error-messages="errors.collect('form.tenant_contacts')"
                                data-vv-name="form.tenant_contacts"
                                data-vv-as="Tenant Contact"
                            >
                              <template v-slot:append>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <v-icon @click="createUser(1)" v-on="on">mdi-plus</v-icon>
                                  </template>
                                  <span>Create a new tenant contact</span>
                                </v-tooltip>
                              </template>
                          </v-autocomplete>
                        </v-col>
                    </v-row>
                  </template>

                  <v-divider class="my-8"></v-divider>

                  <template id="section-areas">
                    <h5 class="text-h7 mb-1 pa-0">Areas</h5>
                    <v-row>
                        
                        <v-col cols="4" v-if="areaChecklist.nia_sqrt || areaChecklist.mezzanine || areaChecklist.garden_centre || areaChecklist.itza_area || areaChecklist.ground_floor_area || areaChecklist.first_floor_area || areaChecklist.second_floor_area || areaChecklist.third_floor_area || areaChecklist.basement_area || areaChecklist.frontage_area">
                            <!-- dont show area type if there arent any fields that use it -->
                            <v-autocomplete
                            outlined
                            dense
                            hide-details
                            v-model="form.area_size_type"
                            :items="[{value:'sqft', name:'sqft'}, {value:'sqm', name:'sqm'}]"
                            cache-items
                            flat
                            hide-no-data
                            clearable
                            item-text="name"
                            item-value="value"
                            label="Area"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="4" v-if="areaChecklist.nia_sqrt">
                            <v-text-field
                            outlined
                                dense
                                hide-details
                                v-model="form.nia_sqrt"
                                v-validate="''"
                                :error-messages="errors.collect('form.nia_sqrt')"
                                label="NIA"
                                data-vv-name="form.nia_sqrt"
                                data-vv-as="NIA"
                                type="number"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4" v-if="areaChecklist.mezzanine">
                            <v-text-field
                            outlined
                                dense
                                hide-details
                                v-model="form.mezzanine"
                                v-validate="''"
                                :error-messages="errors.collect('form.mezzanine')"
                                label="Mezz/FF"
                                data-vv-name="form.mezzanine"
                                data-vv-as="Mezz/FF"
                                type="number"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4" v-if="areaChecklist.garden_centre">
                            <v-text-field
                            outlined
                                dense
                                hide-details
                                v-model="form.garden_centre"
                                v-validate="''"
                                :error-messages="errors.collect('form.garden_centre')"
                                label="GC"
                                data-vv-name="form.garden_centre"
                                data-vv-as="GC"
                                type="number"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4" v-if="areaChecklist.itza_area">
                            <v-text-field
                            outlined
                                dense
                                hide-details
                                v-model="form.itza_area"
                                v-validate="''"
                                :error-messages="errors.collect('form.itza_area')"
                                label="ITZA"
                                data-vv-name="form.itza_area"
                                data-vv-as="ITZA"
                                type="number"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4" v-if="areaChecklist.ground_floor_area">
                            <v-text-field
                            outlined
                                dense
                                hide-details
                                v-model="form.ground_floor_area"
                                v-validate="''"
                                :error-messages="errors.collect('form.ground_floor_area')"
                                label="Ground Floor"
                                data-vv-name="form.ground_floor_area"
                                data-vv-as="Ground Floor"
                                type="number"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4" v-if="areaChecklist.first_floor_area">
                            <v-text-field
                            outlined
                                dense
                                hide-details
                                v-model="form.first_floor_area"
                                v-validate="''"
                                :error-messages="errors.collect('form.first_floor_area')"
                                label="First Floor"
                                data-vv-name="form.first_floor_area"
                                data-vv-as="First Floor"
                                type="number"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4" v-if="areaChecklist.second_floor_area">
                            <v-text-field
                            outlined
                                dense
                                hide-details
                                v-model="form.second_floor_area"
                                v-validate="''"
                                :error-messages="errors.collect('form.second_floor_area')"
                                label="Second Floor"
                                data-vv-name="form.second_floor_area"
                                data-vv-as="Second Floor"
                                type="number"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4" v-if="areaChecklist.third_floor_area">
                            <v-text-field
                            outlined
                                dense
                                hide-details
                                v-model="form.third_floor_area"
                                v-validate="''"
                                :error-messages="errors.collect('form.third_floor_area')"
                                label="Third Floor"
                                data-vv-name="form.third_floor_area"
                                data-vv-as="Third Floor"
                                type="number"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4" v-if="areaChecklist.basement_area">
                            <v-text-field
                            outlined
                                dense
                                hide-details
                                v-model="form.basement_area"
                                v-validate="''"
                                :error-messages="errors.collect('form.basement_area')"
                                label="Basement"
                                data-vv-name="form.basement_area"
                                data-vv-as="Basement"
                                type="number"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4" v-if="areaChecklist.frontage_area">
                            <v-text-field
                            outlined
                                dense
                                hide-details
                                v-model="form.frontage_area"
                                v-validate="''"
                                :error-messages="errors.collect('form.frontage_area')"
                                label="Frontage"
                                data-vv-name="form.frontage_area"
                                data-vv-as="Frontage"
                                type="number"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4">
                          <v-menu offset-y :close-on-content-click="false">
                            <template v-slot:activator="{ on: onMenu }">
                              <v-btn @click="" height="40" width="100%" color="primary" outlined v-on="onMenu">
                                <v-icon>mdi-plus</v-icon>
                                Add Areas
                              </v-btn>
                            </template>
                            <!-- checkbox for each area type -->
                            <v-card style="width: 400px;" class="px-4 py-4">
                              <v-row>
                                <v-col cols="6">
                                    <v-checkbox class="mt-0" :ripple="false" hide-details v-model="areaChecklist.nia_sqrt" label="NIA"></v-checkbox>
                                  </v-col>
                                  <v-col cols="6">
                                    <v-checkbox class="mt-0" :ripple="false" hide-details v-model="areaChecklist.mezzanine" label="Mezz/FF"></v-checkbox>
                                    </v-col>
                                  <v-col cols="6">
                                    <v-checkbox class="mt-0" :ripple="false" hide-details v-model="areaChecklist.garden_centre" label="GC"></v-checkbox>
                                    </v-col>
                                  <v-col cols="6">
                                    <v-checkbox class="mt-0" :ripple="false" hide-details v-model="areaChecklist.itza_area" label="ITZA"></v-checkbox>
                                    </v-col>
                                  <v-col cols="6">
                                    <v-checkbox class="mt-0" :ripple="false" hide-details v-model="areaChecklist.ground_floor_area" label="Ground Floor"></v-checkbox>
                                    </v-col>
                                  <v-col cols="6">
                                    <v-checkbox class="mt-0" :ripple="false" hide-details v-model="areaChecklist.first_floor_area" label="First Floor"></v-checkbox>
                                    </v-col>
                                  <v-col cols="6">
                                    <v-checkbox class="mt-0" :ripple="false" hide-details v-model="areaChecklist.second_floor_area" label="Second Floor"></v-checkbox>
                                    </v-col>
                                  <v-col cols="6">
                                    <v-checkbox class="mt-0" :ripple="false" hide-details v-model="areaChecklist.third_floor_area" label="Third Floor"></v-checkbox>
                                    </v-col>
                                  <v-col cols="6">
                                    <v-checkbox class="mt-0" :ripple="false" hide-details v-model="areaChecklist.basement_area" label="Basement"></v-checkbox>
                                    </v-col>
                                  <v-col cols="6">
                                    <v-checkbox class="mt-0" :ripple="false" hide-details v-model="areaChecklist.frontage_area" label="Frontage"></v-checkbox>
                                </v-col>
                              </v-row>
                            </v-card>
                          </v-menu>
                        </v-col>
                    </v-row>
                  </template>

                  <v-divider class="my-8"></v-divider>

                  <template id="section-lease">
                    <h5 class="text-h7 mb-1 pa-0">Lease Info</h5>
                    <v-row>
                        <v-col cols="6">
                            <!-- <v-text-field
                                outlined
                                dense
                                hide-details
                                v-model="form.lease_start_date"
                                v-validate="''"
                                :error-messages="errors.collect('form.lease_start_date')"
                                placeholder="dd/mm/yyyy"
                                label="Lease Start Date"
                                data-vv-name="form.lease_start_date"
                                data-vv-as="Lease Start Date"
                                mask="##/##/####"
                                v-mask="'##/##/####'"
                                append-icon="mdi-calendar"
                            ></v-text-field> -->
                            <date-input
                              v-model="form.lease_start_date"
                              label="Lease Start Date"
                            ></date-input>
                        </v-col>
                        <v-col cols="6">
                            <!-- <v-text-field
                                outlined
                                dense
                                hide-details
                                v-model="form.lease_end_date"
                                v-validate="''"
                                :error-messages="errors.collect('form.lease_end_date')"
                                placeholder="dd/mm/yyyy"
                                label="Lease End Date"
                                data-vv-name="form.lease_end_date"
                                data-vv-as="Lease End Date"
                                mask="##/##/####"
                                v-mask="'##/##/####'"
                                append-icon="mdi-calendar"
                            ></v-text-field> -->
                            <date-input
                              v-model="form.lease_end_date"
                              label="Lease End Date"
                            ></date-input>
                        </v-col>
                        <v-col cols="6">
                            <!-- <v-text-field
                                outlined
                                dense
                                hide-details
                                v-model="form.next_review_date"
                                v-validate="''"
                                :error-messages="errors.collect('form.next_review_date')"
                                placeholder="dd/mm/yyyy"
                                label="Next Review Date"
                                data-vv-name="form.next_review_date"
                                data-vv-as="Next Review Date"
                                mask="##/##/####"
                                v-mask="'##/##/####'"
                                append-icon="mdi-calendar"
                            ></v-text-field> -->
                            <date-input
                              v-model="form.next_review_date"
                              label="Next Review Date"
                            ></date-input>
                        </v-col>
                        <v-col cols="6">
                            <!-- <v-text-field
                                outlined
                                dense
                                hide-details
                                v-model="form.break_date"
                                v-validate="''"
                                :error-messages="errors.collect('form.break_date')"
                                placeholder="dd/mm/yyyy"
                                label="Break Date"
                                data-vv-name="form.break_date"
                                data-vv-as="Break Date"
                                mask="##/##/####"
                                v-mask="'##/##/####'"
                                append-icon="mdi-calendar"
                            ></v-text-field> -->
                            <date-input
                              v-model="form.break_date"
                              label="Break Date"
                            ></date-input>
                        </v-col>
                        <v-col cols="6">
                          <v-textarea
                          
                            v-model="form.rent_review_clause"
                            label="Rent Review Clause"
                            data-vv-name="form.rent_review_clause"
                            data-vv-as="Rent Review Clause"
                            outlined
                          ></v-textarea>
                        </v-col>
                        <v-col cols="6">
                          <v-textarea
                            v-model="form.break_clause"
                            label="Break Clause"  
                            data-vv-name="form.break_clause"
                            data-vv-as="Break Clause"
                            outlined
                          ></v-textarea>
                        </v-col>
                    </v-row>
                  </template>

                  <v-divider class="my-8"></v-divider>

                  <template id="section-rent-info">
                    <h5 class="text-h7 mb-1 pa-0">Rent Info</h5>
                    <v-row>
                        <v-col cols="12">
                            <currency-select v-model="form.currency" ref="currencySelectRef" label="Currency"></currency-select>
                        </v-col>
                        <v-col cols="6">
                            <currency-input
                              v-model="form.rent_pa"
                              :validation="'decimal:2'"
                              label="Rent Pa"
                              :errorMsgs="errors.collect('form.rent_pa')"
                              :currency="form.currency ? form.currency.symbol : ''"
                            ></currency-input>
                        </v-col>
                        <v-col cols="6">
                            <!-- <v-text-field
                                outlined
                                dense
                                hide-details
                                v-model="form.rent_sqft"
                                v-validate="''"
                                :error-messages="errors.collect('form.rent_sqft')"
                                label="Rent per sqft"
                                data-vv-name="form.rent_sqft"
                                data-vv-as="Rent per sqft"
                                type="number"
                            ></v-text-field> -->
                            <currency-input
                              v-model="form.rent_sqft"
                              :validation="'decimal:2'"
                              label="Rent per sqft"
                              :errorMsgs="errors.collect('form.rent_sqft')"
                              :currency="form.currency ? form.currency.symbol : ''"
                            ></currency-input>
                        </v-col>
                        <v-col cols="6">
                            <!-- <v-text-field
                                outlined
                                dense
                                hide-details
                                v-model="form.rateable_value"
                                v-validate="''"
                                :error-messages="errors.collect('form.rateable_value')"
                                label="Rateable Value"
                                data-vv-name="form.rateable_value"
                                data-vv-as="Rateable Value"
                                type="number"
                            ></v-text-field> -->
                            <currency-input
                              v-model="form.rateable_value"
                              :validation="'decimal:2'"
                              label="Rateable Value"
                              :errorMsgs="errors.collect('form.rateable_value')"
                              :currency="form.currency ? form.currency.symbol : ''"
                            ></currency-input>
                        </v-col>
                        <v-col cols="6">
                            <!-- <v-text-field
                                outlined
                                dense
                                hide-details
                                v-model="form.service_charge"
                                v-validate="''"
                                :error-messages="errors.collect('form.service_charge')"
                                label="Service Charge"
                                data-vv-name="form.service_charge"
                                data-vv-as="Service Charge"
                                type="number"
                            ></v-text-field> -->
                            <currency-input
                              v-model="form.service_charge"
                              :validation="'decimal:2'"
                              label="Service Charge"
                              :errorMsgs="errors.collect('form.service_charge')"
                              :currency="form.currency ? form.currency.symbol : ''"
                            ></currency-input>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                                outlined
                                dense
                                hide-details
                                v-model="form.incentive"
                                v-validate="''"
                                :error-messages="errors.collect('form.incentive')"
                                label="Incentive"
                                data-vv-name="form.incentive"
                                data-vv-as="Incentive"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                                outlined
                                dense
                                hide-details
                                v-model="form.planning"
                                v-validate="''"
                                :error-messages="errors.collect('form.planning')"
                                label="Planning"
                                data-vv-name="form.planning"
                                data-vv-as="Planning"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                  </template>

                  <v-divider class="my-8"></v-divider>

                  <template id="section-contacts">
                    <h5 class="text-h7 mb-1 pa-0">Landlord Contacts</h5>
                    <v-row>
                        <v-col cols="6">
                            <v-autocomplete
                                outlined
                                small-chips
                                deletable-chips
                                multiple
                                hide-details
                                v-model="form.landlords"
                                :loading="landlords.loading"
                                :items="landlords.items"
                                :search-input.sync="landlords.search"
                                cache-items
                                flat
                                return-object
                                hide-no-data
                                clearable
                                item-text="name"
                                item-value="id"
                                label="Landlords"
                                v-validate="''"
                                :error-messages="errors.collect('form.landlords')"
                                data-vv-name="form.landlords"
                                data-vv-as="Landlord"
                            >
                              <template v-slot:append>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <v-icon @click="createCompany(3)" v-on="on">mdi-plus</v-icon>
                                  </template>
                                  <span>Create a new landlord</span>
                                </v-tooltip>
                              </template>

                          </v-autocomplete>
                        </v-col>
                        <v-col cols="6">
                            <v-autocomplete
                                outlined
                                small-chips
                                deletable-chips
                                multiple
                                hide-details
                                v-model="form.landlord_contacts"
                                :loading="landlordContacts.loading"
                                :items="landlordContacts.items"
                                :search-input.sync="landlordContacts.search"
                                cache-items
                                flat
                                return-object
                                hide-no-data
                                clearable
                                item-text="name"
                                item-value="id"
                                label="Landlord Contacts"
                                v-validate="''"
                                :error-messages="errors.collect('form.landlord_contacts')"
                                data-vv-name="form.landlord_contacts"
                                data-vv-as="Landlord Contact"
                            >
                              <template v-slot:append>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <v-icon @click="createUser(3)" v-on="on">mdi-plus</v-icon>
                                  </template>
                                  <span>Create a new landlord contact</span>
                                </v-tooltip>
                              </template>
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="6">
                            <v-autocomplete
                                outlined
                                small-chips
                                deletable-chips
                                multiple
                                hide-details
                                v-model="form.landlord_agents"
                                :loading="landlordAgents.loading"
                                :items="landlordAgents.items"
                                :search-input.sync="landlordAgents.search"
                                cache-items
                                flat
                                return-object
                                hide-no-data
                                clearable
                                item-text="name"
                                item-value="id"
                                label="Landlord Agents"
                                v-validate="''"
                                :error-messages="errors.collect('form.landlord_agents')"
                                data-vv-name="form.landlord_agents"
                                data-vv-as="Landlord Agent"
                            >
                              <template v-slot:append>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <v-icon @click="createCompany(4)" v-on="on">mdi-plus</v-icon>
                                  </template>
                                  <span>Create a new landlord agent</span>
                                </v-tooltip>
                              </template>

                          </v-autocomplete>
                        </v-col>
                        <v-col cols="6">
                            <v-autocomplete
                                outlined
                                small-chips
                                deletable-chips
                                multiple
                                hide-details
                                v-model="form.landlord_agent_contacts"
                                :loading="landlordAgentContacts.loading"
                                :items="landlordAgentContacts.items"
                                :search-input.sync="landlordAgentContacts.search"
                                cache-items
                                flat
                                return-object
                                hide-no-data
                                clearable
                                item-text="name"
                                item-value="id"
                                label="Landlord Agent Contacts"
                                v-validate="''"
                                :error-messages="errors.collect('form.landlord_agent_contacts')"
                                data-vv-name="form.landlord_agent_contacts"
                                data-vv-as="Landlord Agent Contact"
                            >
                              <template v-slot:append>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <v-icon @click="createUser(2)" v-on="on">mdi-plus</v-icon>
                                  </template>
                                  <span>Create a new landlord agent contact</span>
                                </v-tooltip>
                              </template>
                          
                          </v-autocomplete>
                        </v-col>
                    </v-row>
                  </template>

                  <!-- <v-divider class="my-8"></v-divider> -->

                  <!-- <template id="section-tenant-contacts">
                    <h5 class="text-h7 mb-1 pa-0">Tenant Contacts</h5>
                    
                  </template> -->
                </form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed @click="closeDialog">Cancel</v-btn>
                <v-btn depressed :loading="loading"  color="primary" @click="submit">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import {mask} from 'vue-the-mask'
import countries from '@/data/countries'
import CurrencySelect from "@/components/common/currencySelect.vue";
import currencyInput from "@/components/common/currencyInput.vue";
import AddressFinder from "@/components/common/addressFinder.vue";

import CreateCompanyDialog from '@/components/companies/createCompanyDialog'
import CreateUserDialog from '@/components/users/createUserDialog'

import dateInput from '@/components/common/dateInput.vue'

export default {
  components: {
    CurrencySelect,
    currencyInput,
    AddressFinder,
    CreateCompanyDialog,
    CreateUserDialog,
    dateInput,
  },
  directives: {
    mask,
  },
  data: () => ({
     
    dialog: false,
    countries: countries,
    step: 1,
    schemeTypes: [
      'Leisure',
      'Out of town',
      'Shopping centres',
    ],
    landlordContacts: {
      loading: false,
      items: [],
      search: null,
    },
    landlordAgentContacts: {
      loading: false,
      items: [],
      search: null,
    },
    landlords: {
      loading: false,
      items: [],
      search: null,
    },
    landlordAgents: {
      loading: false,
      items: [],
      search: null,
    },
    tenants: {
      loading: false,
      items: [],
      search: null,
    },
    legalTenants: {
      loading: false,
      items: [],
      search: null,
    },
    tenantAgents: {
      loading: false,
      items: [],
      search: null,
    },
    tenantAgentContacts: {
      loading: false,
      items: [],
      search: null,
    },
    tenantContacts: {
      loading: false,
      items: [],
      search: null,
    },
    loading: false,

    place: null,
    form: {
      building_num: '',
      company_id: null,
      legal_tenant_id: null,
      nia_sqrt: '',
      area_size_type: 'sqft',
      itza_area: '',
      ground_floor_area: '',
      first_floor_area: '',
      second_floor_area: '',
      third_floor_area: '',
      basement_area: '',
      frontage_area: '',

      lease_start_date: '',
      lease_end_date: '',
      next_review_date: '',
      break_date: '',
      rent_review_clause: '',
      break_clause: '',
      rent_pa: '',
      rent_sqft: '',
      incentive: '',
      currency: null,

      mezzanine: '',
      garden_centre: '',
      rateable_value: '',
      service_charge: '',
      planning: '',

      landlords: [],
      landlord_contacts: [],
      landlord_agents: [],
      landlord_agent_contacts: [],
      tenant_agents: [],
      tenant_agent_contacts: [],
      tenant_contacts: [],
      address: {
        street: '',
        street2: '',
        city: '',
        region: '',
        post_code: '',
        country: 'United Kingdom',
        notes: '',
        latitude: null,
        longitude: null,
      },
    },
    initialForm: {},

    areaChecklist: {
      nia_sqrt: false,
      mezzanine: false,
      garden_centre: false,
      itza_area: false,
      ground_floor_area: false,
      first_floor_area: false,
      second_floor_area: false,
      third_floor_area: false,
      basement_area: false,
      frontage_area: false,
    },

    creation_ids: {
      company: null,
      user: null,
    },

  }),
  watch: {
    'landlords.search'(search) {
      this.getCompanies(search);
    },
    'landlordContacts.search'(search) {
      this.getUsers(search);
    },
    'landlordAgents.search'(search) {
      this.getCompanies(search);
    },
    'landlordAgentContacts.search'(search) {
      this.getUsers(search);
    },
    'tenants.search'(search) {
      this.getTenants(search);
    },
    'legalTenants.search'(search) {
      this.getLegalTenants(search);
    },
    'tenantAgents.search'(search) {
      this.getTenantAgents(search);
    },
    'tenantAgentContacts.search'(search) {
      this.getTenantAgentContacts(search);
    },
    'tenantContacts.search'(search) {
      this.getTenantContacts(search);
    },
  },
  computed: {
    formValidated() {
      return Object.keys(this.fields).some(key => this.fields[key].validated) &&
        Object.keys(this.fields).some(key => this.fields[key].valid)
    },
    formHasChanges() {
      return JSON.stringify(this.form) !== JSON.stringify(this.initialForm)
    }
  },
  methods: {
    verifyRetailer(retailer){
      if(!retailer || !retailer.scraper) return
      let object ={
        icon: 'grey',
        tooltip: 'This retailer has never been verified',
      }
      if((retailer.scraper.data && retailer.scraper.data.verified_at) || retailer.scraper.verified_at){
        if(retailer.is_verified){
          object.icon = 'green'
          object.tooltip = 'This retailer is verified'
        }else{
          object.icon = 'orange lighten-1'
          object.tooltip = 'This retailer is not currently verified'
        }
      }
      return object
    },
    closeDialog() {
      this.$emit('close')
      this.dialog = false
    },
    openDialog(prefill) {
      this.dialog = true
      // next tick
      // if (address){
      //   this.form.address = address
      // }
      // if (coordinates){
      //   this.form.address.latitude = coordinates.lat
      //   this.form.address.longitude = coordinates.lng
      // }

      if (prefill){
        // prefill is structured like form but does not include all the blank data, so merge it with the initial form
        this.form = Object.assign({}, this.form, prefill)
        if (this.form.company_id){
          this.tenants.items.push(this.form.company_id)
        }
      }
      this.$nextTick(() => {
        this.form.currency = this.$refs.currencySelectRef.selectByCode(this.$auth.user().currency ? this.$auth.user().currency : 'GBP')
      })
    },

    clearForm() {
      this.form = Object.assign({}, this.initialForm)
    },

    async getTenants(search) {
      const response = await this.$http.get('/companies/', {
        params: {
          include: 'scraper',
          q: search,
          per_page: 100,
        }
      });
      this.tenants.items = response.data.data;
    },
    async getLegalTenants(search) {
      const response = await this.$http.get('/companies/', {
        params: {
          include: 'scraper',
          q: search,
          per_page: 100,
        }
      });
      this.legalTenants.items = response.data.data;
    },
    async getTenantAgents(search) {
      const response = await this.$http.get('/companies/', {
        params: {
          q: search,
          per_page: 100,
        }
      });
      this.tenantAgents.items = response.data.data;
    },
    async getTenantAgentContacts(search) {
      const response = await this.$http.get('/users/', {
        params: {
          q: search,
          per_page: 100,
        }
      });
      this.tenantAgentContacts.items = response.data.data;
    },
    async getTenantContacts(search) {
      const response = await this.$http.get('/users/', {
        params: {
          q: search,
          per_page: 100,
        }
      });
      this.tenantContacts.items = response.data.data;
    },
    async getCompanies(search) {
      const response = await this.$http.get('/companies/', {
        params: {
          include: 'scraper',
          q: search,
          per_page: 100,
        }
      });
      this.landlords.items = response.data.data;
      this.landlordAgents.items = response.data.data;
    },
    async getUsers(search) {
      const response = await this.$http.get('/users/', {
        params: {
          q: search,
          per_page: 100,
        }
      });
      this.landlordContacts.items = response.data.data;
      this.landlordAgentContacts.items = response.data.data;
    },
    prepareFormData() {
      let form = Object.assign({}, this.form)
      form.lease_start_date = this.formatDate(this.form.lease_start_date)
      form.lease_end_date = this.formatDate(this.form.lease_end_date)
      form.next_review_date = this.formatDate(this.form.next_review_date)
      form.break_date = this.formatDate(this.form.break_date)
      form.currency = form.currency.code
      form.company_id = form.company_id ? form.company_id.id : null
      form.legal_tenant_id = form.legal_tenant_id ? form.legal_tenant_id.id : null
      form.tenant_agents = form.tenant_agents.map(agent => agent.id)
      form.tenant_agent_contacts = form.tenant_agent_contacts.map(contact => contact.id)
      form.tenant_contacts = form.tenant_contacts.map(contact => contact.id)
      form.landlords = form.landlords.map(landlord => landlord.id)
      form.landlord_contacts = form.landlord_contacts.map(contact => contact.id)
      form.landlord_agents = form.landlord_agents.map(agent => agent.id)
      form.landlord_agent_contacts = form.landlord_agent_contacts.map(contact => contact.id)

      // go t

      return form;
    },
    formatDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    changePlace(place) {
      const addressComponents = place.address_components;
      const getComponent = (type) => addressComponents.find((component) => component.types.includes(type));

      // Populate address fields
      const streetNumber = getComponent('street_number');
      const route = getComponent('route');
      const locality = getComponent('locality');
      const postalTown = getComponent('postal_town');
      const adminArea = getComponent('administrative_area_level_1'); // State
      const postalCode = getComponent('postal_code');
      const country = getComponent('country');

      let address = {
        line1: streetNumber  && route ? `${streetNumber.long_name} ${route.long_name}` : route ? route.long_name : '',
        line2: '',
        city: locality ? locality.long_name : postalTown ? postalTown.long_name : '',
        state: adminArea ? adminArea.long_name : '',
        zip: postalCode ? postalCode.long_name : '',
        country: country ? country.long_name : '',
      }

      this.fillAddress(address)

    },

    selectAddress() {
      this.$refs.addressFinderDialog.openDialog()
    },
    fillAddress(address) {
      this.form.address = {
        street: '',
        street2: '',
        city: '',
        region: '',
        post_code: '',
        country: '',
        notes: '',
      }

      this.form.address.street = address.line1
      this.form.address.street2 = address.line2
      this.form.address.city = address.city
      this.form.address.region = address.state
      this.form.address.post_code = address.zip
      this.form.address.country = address.country
    },

    createUser(id){
      this.creation_ids.user = id
      this.$refs.createUserDialog.showDialog()
    },

    createCompany(id){
      this.creation_ids.company = id
      this.$refs.createCompanyDialog.showDialog()
    },

    fillUser(user){
      // use the creation id to fill the correct field using case statement, id 0 is tenant agent contact, 1 is tenant contact etc etc
      switch(this.creation_ids.user){
        case 0:
          this.tenantAgentContacts.items.push(user)
          this.form.tenant_agent_contacts.push(user)
          break;
        case 1:
          this.tenantContacts.items.push(user)
          this.form.tenant_contacts.push(user)
          break;
        case 2:
          this.landlordAgentContacts.items.push(user)
          this.form.landlord_agent_contacts.push(user)
          break;
        case 3:
          this.landlordContacts.items.push(user)
          this.form.landlord_contacts.push(user)
          break;
        default:
          break;
      }
    },

    fillCompany(company){
      // same as fill user, except for companies, 0 is tenant, 1 is legal tenant, 2 is tenant agent, 3 is landlords, 4 is landlord agent
      switch(this.creation_ids.company){
        case 0:
          this.tenants.items.push(company)
          this.form.company_id = company
          break;
        case 1:
          this.legalTenants.items.push(company)
          this.form.legal_tenant_id = company
          break;
        case 2:
          this.tenantAgents.items.push(company)
          this.form.tenant_agents.push(company)
          break;
        case 3:
          this.landlords.items.push(company)
          this.form.landlords.push(company)
          break;
        case 4:
          this.landlordAgents.items.push(company)
          this.form.landlord_agents.push(company)
          break;
        default:
          break;
      }
    },

    async submit() {
      this.loading = true
      let formData = this.prepareFormData()
      await this.$http.post('/properties', formData).then(response => {
        formData.id = response.data.data.id
        formData.entity_type = 'property'
        formData.tenant = this.form.company_id
        this.$emit('added', formData)
        this.loading = false
        this.clearForm()
        this.closeDialog()
      }).catch(error => {
        this.loading = false
        this.$store.dispatch('handleError', error)
      })
      
    }
  },
  mounted() {
    this.initialForm = {
      building_num: '',
      company_id: null,
      legal_tenant_id: null,
      nia_sqrt: '',
      area_size_type: 'sqft',
      itza_area: '',
      ground_floor_area: '',
      first_floor_area: '',
      second_floor_area: '',
      third_floor_area: '',
      basement_area: '',
      frontage_area: '',

      lease_start_date: '',
      lease_end_date: '',
      next_review_date: '',
      break_date: '',
      rent_review_clause: '',
      break_clause: '',
      rent_pa: '',
      rent_sqft: '',
      incentive: '',
      currency: null,

      mezzanine: '',
      garden_centre: '',
      rateable_value: '',
      service_charge: '',
      planning: '',

      landlords: [],
      landlord_contacts: [],
      landlord_agents: [],
      landlord_agent_contacts: [],
      tenant_agents: [],
      tenant_agent_contacts: [],
      tenant_contacts: [],
      address: {
        street: '',
        street2: '',
        city: '',
        region: '',
        post_code: '',
        country: 'United Kingdom',
        notes: '',
        latitude: null,
        longitude: null,
      },
    }
  }
}
</script>